// =============================================================================
// LEADERBOARD CONSTANTS — SSOT
// =============================================================================
// Extracted from CalculationsDrawer.tsx so HoverTooltip + FormulaGuide can
// import without circular deps. CalculationsDrawer imports from here too.
// =============================================================================

export type SectorFilter = "closer" | "setter" | "dialer";

// Points awarded per daily rank position
export const POINTS_PER_RANK = [
  { rank: "1st", pts: 5 },
  { rank: "2nd", pts: 3 },
  { rank: "3rd", pts: 2 },
  { rank: "4th", pts: 1 },
  { rank: "5th+", pts: 0 },
];

// Per-sector weighted blend — controls both rank_score computation and UI display
export const SECTOR_WEIGHTS: Record<SectorFilter, { label: string; pct: number; desc: string }[]> =
  {
    closer: [
      { label: "Cash", pct: 50, desc: "Total cash collected" },
      {
        label: "Show Rate",
        pct: 25,
        desc: "% of booked calls where lead actually showed (incl. orphans)",
      },
      { label: "CPC", pct: 25, desc: "Cash collected ÷ shows (calls where lead showed up)" },
    ],
    setter: [
      { label: "CPC", pct: 40, desc: "Cash ÷ pre-calls filed (real qualified bookings)" },
      {
        label: "Show Rate",
        pct: 30,
        desc: "% of booked calls where lead actually showed (incl. orphans)",
      },
      { label: "Booked", pct: 30, desc: "Pre-call forms submitted (the booking signal)" },
    ],
    // Dialer mirrors the setter (2026-06-02, Session 25). Dials + CTB dropped:
    // daily_dials and connect_to_book_rate are never populated.
    dialer: [
      { label: "CPC", pct: 40, desc: "Cash ÷ pre-calls filed (solo-dialer bookings)" },
      {
        label: "Show Rate",
        pct: 30,
        desc: "% of booked calls where lead showed (incl. orphans)",
      },
      { label: "Booked", pct: 30, desc: "Solo-dialer pre-calls (setter-shared excluded)" },
    ],
  };

// Min-volume gate — reps below this threshold are unranked in range mode
export const MIN_VOLUME_GATE: Record<SectorFilter, { field: string; min: number; label: string }> =
  {
    closer: { field: "shows", min: 3, label: "≥3 shows" },
    setter: { field: "calls_booked", min: 5, label: "≥5 calls booked" },
    dialer: { field: "calls_booked", min: 5, label: "≥5 calls booked" },
  };
